{
  "addons.addonList": "アドオンリスト",
  "addons.ambientWeatherCreateAndRetrieveApiKey": "このリンクから API キーを作成および取得します",
  "addons.ambientWeatherDescription": "周囲気象ステーション (WS-5000、WS-2000、WS-2902C など)",
  "addons.apiKey": "APIキー",
  "addons.applicationKey": "アプリケーションキー",
  "addons.connect": "接続する",
  "addons.davisApiSecret": "APIシークレット",
  "addons.davisApiV2Key": "V2 API キー",
  "addons.davisDescription": "デイビス気象観測所 (Vantage Vue、Vantage Pro2 など)",
  "addons.davisRetrieveApiKey": "このリンクから V2 API キーを取得します",
  "addons.disconnect": "切断する",
  "addons.ecowittCreateAndRetrieveKeys": "このリンクから API キーとアプリケーション キーの両方を作成および取得します",
  "addons.ecowittDescription": "Ecowitt は、プロ仕様の Wi-Fi 気象ステーション、ワイヤレス屋内屋外温度計、湿度モニター、高精度雨量計、大気質モニターなどを提供しています。",
  "addons.helpLink": "{provider}の接続方法",
  "addons.myAcuriteAccountOnHold": "あなたのアカウントは保留されました。アカウントを再接続するにはパスワードを入力してください",
  "addons.myAcuriteDescription": "AcuRite は、北米でナンバー 1 の気象観測所ブランドです。時間、温度、気象テクノロジーのリーダーとして、AcuRite は屋内と屋外の環境に関する詳細な情報を提供するため、自信を持って 1 日の計画を立てることができます。",
  "addons.myAcuriteEnterCredentials": "My AcuRite アカウントを SmartMixin にリンクするには、My AcuRite 認証情報を入力してください。",
  "addons.netatmoEnergy": "ネタトモ・エネルギー",
  "addons.netatmoEnergyDescription": "Netatmo サーモスタットを使用して、ベッドから、または世界の裏側から家の温度を変更します。",
  "addons.netatmoThermostat": "Netatmo サーモスタット",
  "addons.netatmoWeather": "ネタトモ天気",
  "addons.netatmoWeatherDescription": "自宅の個人気象観測所",
  "addons.or": "または",
  "addons.providerAccountDisconnected": "気象サービスへの接続が期限切れになりました。データ更新を再開するには再接続してください。",
  "addons.reconnect": "再接続",
  "addons.weatherflowCreateToken": "このリンクからトークンを作成して取得します",
  "addons.weatherflowTempestDescription": "風力計、雨量計を内蔵したテンペスト気象システム",
  "addons.wundergroundApiKey": "APIキー",
  "addons.wundergroundDescription": "Weather Underground は、気象観測所や大気質モニターなどの環境センサーからのデータを接続する人々のグローバル コミュニティです。これにより、情熱を高めるために必要なリッチでハイパーローカルなデータを提供できます。",
  "addons.wundergroundRetrieveApiKey": "このリンクから API キーを取得します",
  "addons.wundergroundRetrieveStationId": "このリンクからステーション ID を取得します",
  "addons.wundergroundStationId": "ステーションID",
  "airQuality.airQuality": "空気の質",
  "airQuality.airQualityIndex": "空気の質の指標",
  "airQuality.aqiForecast": "大気質予報",
  "airQuality.co": "一酸化炭素",
  "airQuality.dailyForecast": "毎日の天気予報",
  "airQuality.details": "詳細",
  "airQuality.dominantPollutant": "主要汚染物質",
  "airQuality.good": "良い",
  "airQuality.goodDescription": "大気の質は満足のいくものであると考えられており、大気汚染によるリスクはほとんど、またはまったくありません。",
  "airQuality.hazardous": "危険",
  "airQuality.hazardousDescription": "健康に関する警告: 誰でもより深刻な健康影響を経験する可能性があります",
  "airQuality.indoorAirQuality": "室内空気の質",
  "airQuality.mgm3": "mg/m³",
  "airQuality.moderate": "適度",
  "airQuality.moderateDescription": "空気の質は許容範囲内です。ただし、一部の汚染物質については、大気汚染に異常に敏感なごく少数の人々にとって、中程度の健康上の懸念がある可能性があります。",
  "airQuality.no2": "二酸化窒素",
  "airQuality.o3": "オゾン",
  "airQuality.pm10": "直径10μm以下の粒子",
  "airQuality.pm25": "直径2.5μm以下の粒子",
  "airQuality.ppb": "ppb",
  "airQuality.sensitiveUnhealthy": "敏感な人には不健康",
  "airQuality.sensitiveUnhealthyDescription": "敏感なグループのメンバーは健康への影響を経験する可能性があります。一般人への影響は考えられません。",
  "airQuality.so2": "二酸化硫黄",
  "airQuality.ugm3": "µg/m³",
  "airQuality.unhealthy": "不健康",
  "airQuality.unhealthyDescription": "誰もが健康への影響を経験し始める可能性があります。敏感なグループのメンバーは、より深刻な健康影響を経験する可能性があります",
  "airQuality.veryUnhealthy": "非常に不健康",
  "airQuality.veryUnhealthyDezscription": "緊急事態に関する健康上の警告。人口全体が影響を受ける可能性が高くなります。",
  "alerts.addAlert": "アラートを追加",
  "alerts.addCondition": "条件の追加",
  "alerts.alertAdded": "アラートが正常に追加されました",
  "alerts.alertAuthorizationNotice": "アラートは、SmartMixin に通知の表示を許可した場合にのみ機能します。",
  "alerts.alertDeleted": "アラートは正常に削除されました",
  "alerts.alertEdited": "アラートは正常に変更されました",
  "alerts.alertName": "アラート名",
  "alerts.alertWhen": "次の場合に警告を受け取りたいです。",
  "alerts.aqiGreaterThan": "AQI が次を超えています",
  "alerts.aqiGreaterThanThreshold": "AQI が {value}{unit} のしきい値を超えています",
  "alerts.aqiLessThan": "AQI 未満",
  "alerts.aqiLessThanThreshold": "AQI が {value}{unit} のしきい値未満",
  "alerts.atLeastOneCondition": "少なくとも 1 つの条件を追加する必要があります",
  "alerts.co2GreaterThan": "CO2 が次を超えています",
  "alerts.co2GreaterThanThreshold": "CO2 が {value}{unit} のしきい値を超えています",
  "alerts.co2LessThan": "CO2未満",
  "alerts.co2LessThanThreshold": "CO2 が {value}{unit} しきい値未満",
  "alerts.conditions": "条件",
  "alerts.createAlert": "アラートの作成",
  "alerts.dailyPrecipitationGreaterThan": "日降水量が超過",
  "alerts.dailyPrecipitationGreaterThanThreshold": "日降水量が{value}{unit}の閾値を超過",
  "alerts.deleteAlert": "アラートの削除",
  "alerts.editAlert": "アラートの編集",
  "alerts.editCondition": "編集条件",
  "alerts.gustSpeedGreaterThan": "突風速度以上",
  "alerts.gustSpeedGreaterThanThreshold": "ガスト速度が {value}{unit} のしきい値を超えています",
  "alerts.gustSpeedLessThan": "ガスト速度未満",
  "alerts.gustSpeedLessThanThreshold": "ガスト速度が {value}{unit} のしきい値未満",
  "alerts.heatIndexGreaterThan": "暑さ指数を超える",
  "alerts.heatIndexGreaterThanThreshold": "暑さ指数 が {value}{unit} のしきい値を超えています",
  "alerts.heatIndexLessThan": "暑さ指数未満",
  "alerts.heatIndexLessThanThreshold": "暑さ指数 が {value}{unit} のしきい値未満",
  "alerts.humidexGreaterThan": "ヒュミデックスを超える",
  "alerts.humidexGreaterThanThreshold": "ヒュミデックス が {value}{unit} のしきい値を超えています",
  "alerts.humidexLessThan": "ヒュミデックス未満",
  "alerts.humidexLessThanThreshold": "ヒュミデックス が {value}{unit} のしきい値未満",
  "alerts.humidityGreaterThan": "以上の湿度",
  "alerts.humidityGreaterThanThreshold": "湿度が {value}{unit} のしきい値を超えています",
  "alerts.humidityLessThan": "湿度以下",
  "alerts.humidityLessThanThreshold": "湿度が {value}{unit} のしきい値未満",
  "alerts.inProgress": "進行中",
  "alerts.myAlerts": "私のアラート",
  "alerts.noConfiguredAlert": "まだアラートが設定されていません。アラートの追加を開始してください",
  "alerts.noiseGreaterThan": "を超えるノイズ",
  "alerts.noiseGreaterThanThreshold": "ノイズが {value}{unit} のしきい値を超えています",
  "alerts.noiseLessThan": "騒音以下",
  "alerts.noiseLessThanThreshold": "ノイズが {value}{unit} のしきい値未満",
  "alerts.noteOnConditions": "以下の条件がすべて確認された場合にアラートがトリガーされることに注意してください。",
  "alerts.pm10GreaterThan": "PM10以上",
  "alerts.pm10GreaterThanThreshold": "PM 10 が {value}{unit} のしきい値を超えています",
  "alerts.pm10LessThan": "PM10未満",
  "alerts.pm10LessThanThreshold": "PM 10 が {value}{unit} のしきい値未満",
  "alerts.pm1GreaterThan": "PM1以上",
  "alerts.pm1GreaterThanThreshold": "PM 1 が {value}{unit} のしきい値を超えています",
  "alerts.pm1LessThan": "PM1未満",
  "alerts.pm1LessThanThreshold": "PM 1 が {value}{unit} のしきい値未満",
  "alerts.pm2p5GreaterThan": "PM2.5以上",
  "alerts.pm2p5GreaterThanThreshold": "PM 2.5 が {value}{unit} のしきい値を超えています",
  "alerts.pm2p5LessThan": "PM2.5未満",
  "alerts.pm2p5LessThanThreshold": "PM 2.5 が {value}{unit} のしきい値未満",
  "alerts.postStormSummary": "降雨後のまとめ",
  "alerts.postStormSynopsisHelper": "降雨イベントが終わるたびに、まとめ通知が届きます。",
  "alerts.postStormSynopsisSoleCondition": "嵐の後のまとめは他の条件と組み合わせることはできません。",
  "alerts.precipitationGreaterThan": "1時間降水量が超過",
  "alerts.precipitationGreaterThanThreshold": "1時間降水量が{value}{unit}の閾値を超過",
  "alerts.pressureGreaterThan": "以上の圧力",
  "alerts.pressureGreaterThanThreshold": "圧力が {value}{unit} のしきい値を超えています",
  "alerts.pressureLessThan": "未満の圧力",
  "alerts.pressureLessThanThreshold": "圧力が {value}{unit} のしきい値未満です",
  "alerts.rainRateGreaterThan": "降水強度が超過",
  "alerts.rainRateGreaterThanThreshold": "降水強度が{value}{unit}の閾値を超過",
  "alerts.solarRadiationGreaterThan": "日射量が超過",
  "alerts.solarRadiationGreaterThanThreshold": "日射量が {value}{unit} のしきい値を超えています",
  "alerts.solarRadiationLessThan": "日射量以下",
  "alerts.solarRadiationLessThanThreshold": "日射量が {value}{unit} のしきい値未満",
  "alerts.temperatureGreaterThan": "を超える温度",
  "alerts.temperatureGreaterThanThreshold": "温度が {value}{unit} のしきい値を超えています",
  "alerts.temperatureLessThan": "温度未満",
  "alerts.temperatureLessThanThreshold": "温度が {value}{unit} のしきい値未満",
  "alerts.thswGreaterThan": "THSWを超える",
  "alerts.thswGreaterThanThreshold": "THSW が {value}{unit} のしきい値を超えています",
  "alerts.thswLessThan": "THSW未満",
  "alerts.thswLessThanThreshold": "THSW が {value}{unit} のしきい値未満",
  "alerts.thwGreaterThan": "THWを超える",
  "alerts.thwGreaterThanThreshold": "THW が {value}{unit} のしきい値を超えています",
  "alerts.thwLessThan": "THW未満",
  "alerts.thwLessThanThreshold": "THW が {value}{unit} のしきい値未満",
  "alerts.uvGreaterThan": "UV インデックスが次より大きい",
  "alerts.uvGreaterThanThreshold": "UV インデックスが {value}{unit} のしきい値を超えています",
  "alerts.uvLessThan": "UV インデックス未満",
  "alerts.uvLessThanThreshold": "UV インデックスが {value}{unit} のしきい値未満",
  "alerts.visibilityGreaterThanThreshold": "可視性が {value}{unit} のしきい値を超えています",
  "alerts.visibilityLessThanThreshold": "可視性が {value}{unit} のしきい値未満です",
  "alerts.visiblityGreaterThan": "以上の可視性",
  "alerts.visiblityLessThan": "可視性が以下です",
  "alerts.whichMeasure": "どのメジャーについてアラートを受け取りたいですか?",
  "alerts.whichModule": "どのモジュールをアラートしたいですか？",
  "alerts.windChillGreaterThan": "風の寒さを超える",
  "alerts.windChillGreaterThanThreshold": "風の寒さ が {value}{unit} のしきい値を超えています",
  "alerts.windChillLessThan": "風の寒さ未満",
  "alerts.windChillLessThanThreshold": "風の寒さ が {value}{unit} のしきい値未満",
  "alerts.windSpeedGreaterThan": "風速が以上",
  "alerts.windSpeedGreaterThanThreshold": "風速が {value}{unit} のしきい値を超えています",
  "alerts.windSpeedLessThan": "風速以下",
  "alerts.windSpeedLessThanThreshold": "風速が {value}{unit} のしきい値未満",
  "astral.astronomicalSunPhase": "天文 {sunPhase}",
  "astral.civilSunPhase": "市民 {sunPhase}",
  "astral.dawn": "夜明け",
  "astral.dusk": "夕暮れ",
  "astral.firstQuarter": "上弦の月",
  "astral.fullMoon": "満月",
  "astral.lastQuarter": "下弦の月",
  "astral.moon": "月",
  "astral.moonPhases": "ムーンフェイズ",
  "astral.moonrise": "月の出",
  "astral.moonset": "月の入り",
  "astral.nauticalSunPhase": "航海 {sunPhase}",
  "astral.newMoon": "新月",
  "astral.noon": "正午",
  "astral.remainingDaylight": "残りの日光",
  "astral.sunrise": "日の出",
  "astral.sunriseAndSunset": "日の出と日の入り",
  "astral.sunriseAt": "日の出 {time}",
  "astral.sunset": "日没",
  "astral.sunsetAt": "日の入り {time}",
  "astral.totalDaylight": "総昼光量",
  "astral.waningCrescent": "欠けていく三日月",
  "astral.waningGibbous": "欠けていく凸月",
  "astral.waxingCrescent": "満ちていく三日月",
  "astral.waxingGibbous": "満ちていく凸月",
  "auth.alreadyHaveAccount": "すでにアカウントをお持ちですか？",
  "auth.authContainerTagline": "あなただけの気象ダッシュボード。ステーションを接続して、リアルタイムデータを手元で確認できます。",
  "auth.backToLogin": "ログインに戻る",
  "auth.catchPhrase": "気象情報プラットフォーム",
  "auth.checkYourEmail": "メールを確認してください",
  "auth.continueWithApple": "Appleで続行",
  "auth.continueWithFacebook": "Facebookで続行",
  "auth.continueWithGoogle": "Googleで続行",
  "auth.email": "電子メールアドレス",
  "auth.emailRequiredLoginFacebook": "メールの許可が必要です。",
  "auth.emailVerification": "メール認証",
  "auth.emailVerificationFailure": "メール認証で問題が発生しました。",
  "auth.emailVerificationSuccess": "あなたのメールアドレスは正常に認証されました。",
  "auth.firstName": "ファーストネーム",
  "auth.forgotPassword": "パスワードをお忘れですか？",
  "auth.forgotPasswordSubtitle": "メールアドレスを入力してください。パスワードをリセットするリンクをお送りします。",
  "auth.lastName": "苗字",
  "auth.login": "ログイン",
  "auth.loginSubtitle": "おかえりなさい！詳細を入力してください。",
  "auth.loginToSmartMixinDescription": "SmartMixin 資格情報を入力してアカウントにアクセスします。",
  "auth.logout": "ログアウト",
  "auth.logoutConfirmation": "ログアウトしてもよろしいですか?",
  "auth.noAccountYet": "アカウントをお持ちではありませんか？",
  "auth.or": "または",
  "auth.password": "パスワード",
  "auth.passwordAgain": "パスワードを再入力",
  "auth.passwordReset": "パスワードのリセット",
  "auth.passwordResetSuccess": "パスワードは正常に更新されました。",
  "auth.register": "アカウントを作成する",
  "auth.registerDescription": "無料のSmartMixinアカウントを作成して、気象観測所の接続、気象データの追跡、高度な分析ツールへのアクセスが可能になります。",
  "auth.registerSubtitle": "アカウントを作成して始めましょう。",
  "auth.registerSuccess": "正常に登録されました。詳しい手順を記載した確認リンクを {emailAddress} に送信しました。",
  "auth.restorePassword": "パスワードを復元する",
  "auth.restorePasswordSuccess": "詳しい手順を記載したパスワード リセット リンクを {emailAddress} に送信しました。",
  "auth.sendReset": "リセット指示を送信する",
  "auth.socialAccount": "またはあなたのアカウントを使用してください",
  "auth.welcome": "SmartMixin へようこそ",
  "auth.welcomeBack": "おかえり！",
  "calendar.april": "4月",
  "calendar.august": "8月",
  "calendar.dateFormat": "日付形式",
  "calendar.day": "日",
  "calendar.december": "12月",
  "calendar.end": "終わり",
  "calendar.february": "2月",
  "calendar.hours": "時間",
  "calendar.hoursShort": "時間",
  "calendar.january": "1月",
  "calendar.july": "7月",
  "calendar.june": "6月",
  "calendar.last24Hours": "過去 24 時間",
  "calendar.last30Days": "過去 30 日間",
  "calendar.last7Days": "過去 7 日間",
  "calendar.march": "3月",
  "calendar.max": "マックス",
  "calendar.may": "5月",
  "calendar.month": "月",
  "calendar.months": "月",
  "calendar.november": "11月",
  "calendar.october": "10月",
  "calendar.oneDay": "1日",
  "calendar.oneHour": "1時間",
  "calendar.oneMonth": "1ヶ月",
  "calendar.oneWeek": "1週間",
  "calendar.previous24Hours": "過去 24 時間",
  "calendar.previous30Days": "過去 30 日間",
  "calendar.previous7Days": "過去7日間",
  "calendar.previousDay": "前日",
  "calendar.previousMonth": "前月",
  "calendar.previousWeek": "前の週",
  "calendar.previousYear": "前年",
  "calendar.sameDayLastYear": "去年の同じ日",
  "calendar.sameMonthLastYear": "去年の同じ月",
  "calendar.selectADate": "日付を選択します",
  "calendar.selectAggregation": "表示する値を選択",
  "calendar.selectAMonth": "月を選択します",
  "calendar.selectAYear": "1年を選択してください",
  "calendar.selectGranularity": "粒度を選択してください",
  "calendar.selectTimescale": "タイムスケールを選択してください",
  "calendar.september": "9月",
  "calendar.sixHours": "6時間",
  "calendar.start": "始まり",
  "calendar.thirtyMinutes": "30分",
  "calendar.threeHours": "3時間",
  "calendar.use24HourFormat": "24 時間形式を使用する",
  "calendar.week": "週",
  "calendar.year": "年",
  "calendar.yesterday": "昨日",
  "common.accountDeleted": "アカウントは正常に削除されました。",
  "common.accountOnHold": "アカウントの接続が期限切れになりました。データ更新を再開するには再接続してください。",
  "common.add": "追加",
  "common.addAStation": "観測所を追加する",
  "common.addToFavorites": "お気に入りに追加",
  "common.addYourOwnStation": "自分のステーションを追加する",
  "common.alreadyPremium": "あなたはすでにプレミアムアカウントをお持ちです!",
  "common.alsoAvailableOn": "以下でも利用可能：",
  "common.altitude": "高度",
  "common.analysis": "分析",
  "common.aroundMe": "私の周り",
  "common.articleCount": "{count}件の記事",
  "common.articleNotFound": "記事が見つかりません",
  "common.articleNotFoundDescription": "お探しの記事は存在しません。",
  "common.average": "平均",
  "common.averageOverThePeriod": "期間中の平均",
  "common.away": "離れて",
  "common.back": "戻る",
  "common.backToHelpCenter": "ヘルプセンターに戻る",
  "common.backToHome": "ホームに戻る",
  "common.bad": "悪い",
  "common.batteryLevel": "バッテリー残量",
  "common.bestValue": "ベストバリュー",
  "common.billingDetailsAndroid": "無料トライアルオファーの場合、無料お試し期間が終了する 24 時間前にキャンセルした場合、料金はかかりません。試用期間が終了したら、Google Play アカウント設定からいつでも SmartMixin サブスクリプションをキャンセルできます。キャンセルしない場合は自動的に更新されます。上のボタンに表示されている別の料金が請求されるのを避けるために、これはサブスクリプション期間が終了する 24 時間前までに行う必要があります。サブスクリプションの支払いは、購入の確認時と各更新期間の開始時に Google Play アカウントに請求されます。",
  "common.billingDetailsIos": "無料トライアルオファーの場合、無料お試し期間が終了する 24 時間前にキャンセルした場合、料金はかかりません。試用期間が終了したら、App Store アカウント設定からいつでも SmartMixin サブスクリプションをキャンセルできます。キャンセルしない場合は自動的に更新されます。上のボタンに表示されている別の料金が請求されるのを避けるために、これはサブスクリプション期間が終了する 24 時間前までに行う必要があります。サブスクリプションの支払いは、購入の確認時と各更新期間の開始時に App Store アカウントに請求されます。",
  "common.boilerOn": "ボイラーON",
  "common.browseByCategory": "カテゴリで閲覧",
  "common.calendarView": "カレンダービュー",
  "common.cancel": "キャンセル",
  "common.cannotBeEmpty": "このフィールドを空にすることはできません。",
  "common.cardDetails": "カード詳細",
  "common.categoryNotFound": "カテゴリが見つかりません",
  "common.categoryNotFoundDescription": "このカテゴリは存在しないか、記事がありません。",
  "common.charts": "チャート",
  "common.chartView": "チャートビュー",
  "common.clearRecentLocations": "すべてをクリアします",
  "common.close": "閉じる",
  "common.comparison": "比較",
  "common.contactMe": "お問い合わせ",
  "common.currentDay": "当日",
  "common.currentLocation": "現在の場所",
  "common.currentObservations": "現在の観測結果",
  "common.currentRainEvent": "現在開催中の雨イベント",
  "common.currentRate": "現在のレート",
  "common.currentWeatherConditions": "現在の条件",
  "common.customizeComparisonMetrics": "比較指標をカスタマイズ",
  "common.customizeComparisonMetricsDescription": "項目をドラッグして比較指標を並べ替えます。目のアイコンをタップして指標の表示・非表示を切り替えます。",
  "common.customizeDashboard": "カスタマイズ",
  "common.customizeDashboardDescription": "項目をドラッグしてダッシュボードを並べ替えます。目のアイコンをタップしてセクションの表示・非表示を切り替えます。",
  "common.customizedStationName": "カスタマイズした観測所名",
  "common.dailyForecast": "毎日の天気予報",
  "common.dashboard": "ダッシュボード",
  "common.default": "デフォルト",
  "common.defaultForecastModelChip": "デフォルト · {name}",
  "common.delete": "消去",
  "common.deleteAccount": "アカウントを削除する",
  "common.deleteAccountConfirmation": "アカウントを削除してもよろしいですか?この操作は元に戻すことができません。",
  "common.deleteAccountDescription": "この操作により、アカウントとすべての情報が削除されます。もう後戻りはできません。",
  "common.details": "詳細",
  "common.edit": "編集",
  "common.editor": "編集者",
  "common.endTime": "終了時間",
  "common.exitFullscreen": "全画面表示を終了",
  "common.exploreWeatherMap": "天気マップを見る",
  "common.favoriteLocations": "お気に入り",
  "common.favoriteLocationsEmpty": "最大5つのお気に入りの場所を追加できます。",
  "common.favoriteStations": "お気に入りの観測所",
  "common.feedbackHelpsImprove": "ご意見はヘルプ記事の改善に役立てられます。",
  "common.feedbackReasonNotAnswer": "質問の答えになっていない",
  "common.feedbackReasonOutdated": "情報が古い",
  "common.feedbackReasonUnclear": "手順がわかりにくい",
  "common.feedbackWhatWentWrong": "どのような問題がありましたか?",
  "common.filterStationDescription": "測定値が信頼できない局は表示しない",
  "common.filterStations": "フィルターステーション",
  "common.filterStationSourceDescription": "地図上に表示したい観測所プロバイダーを選択してください",
  "common.findStationsNearYou": "近くの観測所を探す",
  "common.firmwareVersion": "ファームウェアのバージョン",
  "common.forecast": "予報",
  "common.forecastComparisonDescription": "複数のソースからの予測モデル出力を簡単に比較",
  "common.forecastModelComparison": "予測モデルの比較",
  "common.forecastModelCoverage": "対象範囲",
  "common.forecastModelDescription": "説明",
  "common.forecastModelDescription_AROME": "Météo Franceの対流を解像する高解像度モデル。西ヨーロッパを1.3km解像度でカバー。フランスでの短期予報ではクラス最高。3時間ごとに更新。",
  "common.forecastModelDescription_ARPEGE_EU": "Météo FranceのARPEGEモデルのヨーロッパネストで、解像度は10km。ヨーロッパ上空の中期予報で、1日4回更新。",
  "common.forecastModelDescription_ARPEGE_GLOBAL": "Météo Franceの全球数値天気予報モデル。解像度25kmで約4日間まで予報。1日4回更新。",
  "common.forecastModelDescription_DMI_DINI": "DMIのHARMONIE DINI：北西ヨーロッパ（デンマーク、ベネルクス、アイルランド、英国、スカンジナビア）を対象とした、解像度2kmで60時間先までの対流許容モデル。1日8回更新。改変されたDMIオープンデータ（CC BY 4.0）を含みます。",
  "common.forecastModelDescription_EC_GDPS": "Environment Canadaの全球決定論的予測システム：解像度15kmで10日先までの世界的な中期モデル。1日2回更新。",
  "common.forecastModelDescription_EC_HRDPS": "Environment Canadaの高解像度決定論的予測システム：カナダおよび米国北部を対象とした、解像度2.5kmで48時間先までの対流許容モデル。1日4回更新。",
  "common.forecastModelDescription_EC_RDPS": "Environment Canadaの地域決定論的予測システム：北米上空の中期モデルで解像度10km。1日4回更新。",
  "common.forecastModelDescription_ECMWF_HRES": "欧州中期予報センター(ECMWF)の主力高解像度モデル(IFS)。世界最高水準のグローバル予報システムとして広く評価されています。地球全体を25km解像度で最大15日先までカバーし、1日4回更新されます。改変されたECMWFオープンデータ(CC BY 4.0)を含みます。",
  "common.forecastModelDescription_GFS": "NOAAの主力中期全球モデル。解像度25kmで全惑星を16日先までカバーし、1日4回更新。",
  "common.forecastModelDescription_HRRR_CONUS": "NOAAのHigh-Resolution Rapid Refresh：アメリカ本土上空を3km解像度でカバーする対流を解像するモデル。毎時更新。雷雨や悪天候の超短期予報に最適。",
  "common.forecastModelDescription_ICON": "DWDの全球ICONモデル。解像度13 kmで地球全体を7.5日先までカバーし、1日4回更新されます。 Datenbasis: Deutscher Wetterdienst.",
  "common.forecastModelDescription_ICON_2I": "ItaliaMeteoがARPAEと共同運用するICON-2I：イタリアを対象とした、解像度2.2kmで72時間先までの対流許容モデル。1日2回更新。ItaliaMeteoオープンデータ（CC BY 4.0）を含みます。",
  "common.forecastModelDescription_ICON_CH1": "MeteoSwissのICON-CH1-EPSコントロールラン：アルプスを対象とした、解像度1kmで33時間先までの対流許容モデル。3時間ごとに更新。",
  "common.forecastModelDescription_ICON_CH2": "MeteoSwissのICON-CH2-EPSコントロールラン：アルプス（スイスと周辺のアルプス地域）を対象とした、解像度2.1kmで120時間先までの対流許容モデル。1日4回更新。",
  "common.forecastModelDescription_ICON_DE": "DWDの対流を解像する高解像度モデル。ドイツと周辺諸国を2.2km解像度でカバー。短期予報は1日2回更新。 Datenbasis: Deutscher Wetterdienst.",
  "common.forecastModelDescription_ICON_EU": "DWDのICONモデルのヨーロッパネストで、解像度は7km。ヨーロッパと北大西洋をカバー。中期予報は1日4回更新。 Datenbasis: Deutscher Wetterdienst.",
  "common.forecastModelDescription_MET_NORWAY": "ノルウェー気象研究所のオープン天気予報サービス。高解像度の北欧モデルとECMWFデータを組み合わせて、10日先までの世界的な予報を提供。",
  "common.forecastModelDescription_MF_AROME_ANTILLES": "フランス領アンティル諸島（グアドループ、マルティニーク）上空のAROMEネスト、解像度2.5km。短期予報は1日4回更新。",
  "common.forecastModelDescription_MF_AROME_GUYANE": "フランス領ギアナ上空のAROMEネスト、解像度2.5km。短期予報は1日4回更新。",
  "common.forecastModelDescription_MF_AROME_NOUVELLE_CALEDONIE": "ニューカレドニア上空のAROMEネスト、解像度2.5km。短期予報は1日4回更新。",
  "common.forecastModelDescription_MF_AROME_POLYNESIE": "フランス領ポリネシア上空のAROMEネスト、解像度2.5km。短期予報は1日4回更新。",
  "common.forecastModelDescription_MF_AROME_REUNION_MAYOTTE": "レユニオンとマヨット上空のAROMEネスト、解像度2.5km。短期予報は1日4回更新。",
  "common.forecastModelDescription_NAM_CONUS": "NOAAのNorth American Mesoscaleモデルネスト、アメリカ本土上空、解像度5km。短期予報は1日4回更新。",
  "common.forecastModelDescription_NAM_NORTH_AMERICA": "NOAAのNorth American Mesoscaleモデルで、北米全体を32km解像度でカバー。1日4回更新。",
  "common.forecastModelDescription_SMARTMIXIN_MULTIMODEL": "SmartMixinの主力予報。お客様の場所の毎時に対して、利用可能な最良のモデルを選択します — 通常は存在する場合は高解像度の地域モデル（フランスのAROME、ドイツのICON-D2、米国のHRRR、大陸全体のARPEGE Europeなど）を使用し、他の場所では全球モデルに戻ります — そして近隣のソースからギャップを埋めます。結果は、世界中のどこでも14日間カバーする単一のシームレスな予報であり、基礎となるモデルのいずれかが更新されるたびに自動的に更新されます。",
  "common.forecastModelDescription_WEATHERFLOW_FORECAST": "Weatherflowの独自のグローバル予報。複数の数値天気予報モデルと、Tempest気象観測所ネットワークの観測を組み合わせています。10日間の世界的な見通し。",
  "common.forecastModelDetailTitle": "予報モデル",
  "common.forecastModelScopeGlobal": "全球",
  "common.forecastModelScopeGlobalDescription": "このモデルは地球全体をカバーします。",
  "common.forecastModelScopeRegional": "地域",
  "common.forecastModelScopeRegionalDescription": "このモデルは特定の地域のみをカバーします。",
  "common.forecastModelSpecifications": "仕様",
  "common.forecastSources": "予測ソース",
  "common.freeAccount": "無料アカウント",
  "common.freeSubscription": "無料のプレミアム購読",
  "common.freeTrialForPeriod": "{period} 日間の無料トライアル",
  "common.frequency": "頻度",
  "common.full": "満杯",
  "common.fullscreen": "全画面表示",
  "common.getStartedFree": "無料で始める",
  "common.getUnlimitedAccess": "無制限アクセス:",
  "common.good": "良い",
  "common.hail": "ひょう",
  "common.help": "ヘルプ",
  "common.helpCategoryAccount": "アカウント",
  "common.helpCategoryBilling": "請求",
  "common.helpCategoryGettingStarted": "はじめに",
  "common.helpCategoryProviders": "プロバイダー",
  "common.helpCategoryStations": "ステーション",
  "common.helpCategoryTroubleshooting": "トラブルシューティング",
  "common.helpCenter": "ヘルプセンター",
  "common.helpCenterDescription": "よくある質問への回答を見つけ、SmartMixinを最大限に活用する方法を学びましょう。",
  "common.hg": "フロストガード",
  "common.hidden": "非表示",
  "common.hiddenSensors": "非表示のセンサー",
  "common.hiddenStations": "非表示の観測所",
  "common.hiddenStationsDescription": "隣の目のアイコンをタップすることで、ステーションを押し下げることができます。",
  "common.high": "高い",
  "common.home": "家",
  "common.homeConnectService": "気象観測所をお持ちですか？サービスを接続しましょう",
  "common.homeInformation": "ホーム情報",
  "common.homeIntroduction": "外部アカウントの接続を開始して、SmartMixin の機能を楽しんでください。",
  "common.homeName": "家の名前",
  "common.homeSubtitle": "あなたの天気情報をひとつの場所に",
  "common.horizon": "予報期間",
  "common.horizonValue": "最大 {value} 時間",
  "common.iDontKnowYet": "私にはまだ分かりません",
  "common.indoor": "屋内",
  "common.lastRainEvent": "前回の雨のイベント",
  "common.lastUpdate": "最後の更新",
  "common.legendHeavy": "強い",
  "common.legendLight": "弱い",
  "common.legendLightningHelp": "色は過去{minutes}分間の各落雷の経過時間を示します。新しいものは白、古いものは濃い赤で表示されます。",
  "common.legendNewest": "最新",
  "common.legendOldest": "最古",
  "common.legendStationsHelp": "マーカーの色は選択した指標の値を表します。",
  "common.lightningDataAttribution": "雷データ: Blitzortung.org",
  "common.lightningStrikes": "落雷",
  "common.lightningStrikesDescription": "リアルタイムの落雷を地図に表示",
  "common.linkToSection": "このセクションへのリンク",
  "common.loading": "読み込み中",
  "common.location": "位置",
  "common.locationAddedToFavorites": "お気に入りに追加された場所",
  "common.locationNotGranted": "場所の許可は付与されていません。デバイス設定の場所へのアクセスを許可してください。",
  "common.locationRemovedFromFavorites": "お気に入りから削除された場所",
  "common.locations": "所在地",
  "common.low": "低い",
  "common.manage": "管理",
  "common.manageAccount": "アカウントの管理",
  "common.manageMySubscription": "サブスクリプションを管理する",
  "common.manageSensors": "センサーの管理",
  "common.manageSensorsDescription": "アイテムをドラッグしてセンサーを並べ替えます。目のアイコンをタップしてセンサーの表示/非表示を切り替えます。名前をタップして変更します。",
  "common.manualBoost": "マニュアルブースト",
  "common.manualSetpointUntil": "までの手動設定値",
  "common.mapLayers": "地図レイヤー",
  "common.mapLegend": "地図の凡例",
  "common.maxFavoriteLocationsReached": "お気に入りの場所は最大5つしかありません。 1つを削除して別のものを追加します。",
  "common.maximum": "最大",
  "common.measureToDisplay": "表示するまでの測定",
  "common.medium": "中くらい",
  "common.meshSize": "グリッドサイズ",
  "common.minimum": "最小",
  "common.minRead": "{minutes}分で読めます",
  "common.modifyFavoriteStations": "お気に入りのステーションを変更します",
  "common.modifyFavoriteStationsDescription": "お気に入りのステーションをドラッグして並べ替えることができます。リストからそれらを削除することもできます。",
  "common.moduleType": "モジュールの種類",
  "common.monthTotal": "月合計",
  "common.more": "もっと",
  "common.moreInformation": "詳しくは",
  "common.myLocation": "現在地",
  "common.nearbyWeatherStations": "近くの気象観測所",
  "common.next": "次",
  "common.nextHours": "次の時間",
  "common.no": "いいえ",
  "common.noAccountNeeded": "アカウント不要",
  "common.noDataForThisPeriod": "この期間のデータはありません",
  "common.noLocationsFound": "場所が見つかりません",
  "common.noNetatmoWeatherStationYet": "Netatmo 気象観測所はまだありません。",
  "common.noOutdoorModule": "このステーションには機能する屋外モジュールがありません。",
  "common.noSearchResults": "検索に一致する記事がありません",
  "common.noStationsFound": "観測所が見つかりません",
  "common.noThermostatYet": "あなたはまだサーモスタットを持っていません。",
  "common.notNow": "今はしない",
  "common.notPurchasedYet": "こちらはまだ購入されていないようです。",
  "common.noWeatherStation": "気象観測所はありません",
  "common.noWeatherStationYet": "まだ気象観測所がありません。",
  "common.numberOfActiveWarnings": "{warning_count}アクティブな天気警告",
  "common.onThisPage": "このページの内容",
  "common.openSettings": "設定を開く",
  "common.orChooseMonthly": "または月額を選択：",
  "common.outdatedModule": "このモジュールのデータは古くなっています。",
  "common.outdoor": "アウトドア",
  "common.outdoorTemperature": "屋外温度",
  "common.pageNotFound": "ページが見つかりません",
  "common.pageNotFoundDescription": "お探しのページは存在しないか、移動されました。",
  "common.passwordUpdated": "パスワードが正常に更新されました。",
  "common.personalWeatherIntelligence": "あなたのパーソナル天気インテリジェンス",
  "common.platformMobileApp": "モバイルアプリ",
  "common.platformMobileOnly": "モバイルアプリのみ",
  "common.platformWebApp": "ウェブアプリ",
  "common.platformWebOnly": "ウェブアプリのみ",
  "common.popularArticles": "人気の記事",
  "common.premiumAccount": "プレミアムアカウント",
  "common.premiumDescription": "プレミアム サブスクリプションでは、高度な気象分析、チャートの比較、地域の予測モデルなど、多くの追加機能が利用可能になります。",
  "common.premiumFeatureAlerts": "気象アラート",
  "common.premiumFeatureAnalysis": "高度な気象分析",
  "common.premiumFeatureCharts": "チャート比較",
  "common.premiumFeatureExport": "データエクスポート",
  "common.premiumFeatureForecast": "地域予報モデル",
  "common.premiumFeatureNotification": "ステータスバーウィジェット",
  "common.premiumFeatureTitle": "プレミアム機能",
  "common.premiumFeatureWidgets": "ホーム画面ウィジェット",
  "common.pressureSummary": "圧力の概要",
  "common.previous": "前の",
  "common.previousHours": "過去の時間",
  "common.profileUpdated": "プロファイルが正常に更新されました。",
  "common.purchasedNetatmoPro": "以前に Netatmo Pro ({date}) を購入しました。これにより、プレミアム機能のサブセットにアクセスできるようになります。すべてのプレミアム機能にアクセスしたい場合は、次のいずれかのオファーに登録してください。",
  "common.radarDataAttribution": "レーダーデータ: RainViewer.com",
  "common.rain": "雨",
  "common.rainEvents": "雨のイベント",
  "common.rainfallMeasurement": "降雨量測定",
  "common.rainRadar": "雨レーダー",
  "common.rainRadarDescription": "地図上に雨レーダーをオーバーレイ表示します",
  "common.rainSummary": "雨のまとめ",
  "common.range": "範囲",
  "common.recentLocations": "最近の",
  "common.recentLocationsEmpty": "あなたの最近の歴史は空です。",
  "common.recentStations": "最近の観測所",
  "common.relatedArticles": "関連記事",
  "common.relay": "リレー",
  "common.removeFromFavorites": "お気に入りから削除",
  "common.renameSensors": "センサーの名前を変更する",
  "common.resetZoom": "ズームをリセット",
  "common.restorePurchase": "購入商品を復元する",
  "common.room": "部屋",
  "common.rooms": "部屋",
  "common.savingsPercent": "{percent}%お得",
  "common.searchArticles": "記事を検索...",
  "common.searchForALocation": "場所を検索...",
  "common.searchForLocation": "場所を検索する",
  "common.searchForWeatherStation": "気象観測所を検索する",
  "common.searchResults": "検索結果",
  "common.searchResultsEmpty": "結果は見つかりませんでした。",
  "common.searchResultsFound": "{count}件の結果が見つかりました",
  "common.searchStationsDescription": "都市名、住所、または地名を入力して、近くの気象観測所を検索します。",
  "common.searchStationsHint": "上の検索バーを使用して、世界中の気象観測所を見つけましょう。",
  "common.selectStationForComparison": "比較する観測所を選択してください",
  "common.selectWeatherForecastProvider": "気象プロバイダーを選択してください",
  "common.serialNumber": "シリアルナンバー",
  "common.share": "共有",
  "common.shareOutdoorMeasures": "屋外での対策を共有する",
  "common.shareOutdoorMeasuresDescription": "屋外での対策を他の人に公開して、SmartMixin コミュニティに参加してください。屋内対策は決して共有されません。",
  "common.shareYourWeather": "天気を共有する",
  "common.signalStrength": "シグナル強度",
  "common.skip": "スキップ",
  "common.smartThermostat": "スマートサーモスタット",
  "common.smartValve": "スマートバルブ",
  "common.snow": "雪",
  "common.start": "始める",
  "common.startFreeTrial": "無料トライアルを開始",
  "common.startTime": "始まる時間",
  "common.station": "観測所",
  "common.stationAddedToFavorites": "観測所がお気に入りに追加されました",
  "common.stationComparison": "観測所の比較",
  "common.stationComparisonDescription": "過去の気象データを他の観測所と比較する",
  "common.stationInformation": "観測所情報",
  "common.stationName": "観測所名",
  "common.stationObservationsDescription": "気象観測所からの最新の観測値を表示します",
  "common.stationRemovedFromFavorites": "ステーションがお気に入りから削除されました",
  "common.stations": "観測所",
  "common.stationsNear": "近くの観測所",
  "common.stationType": "観測所の種類",
  "common.statusOffline": "オフライン",
  "common.statusOnline": "オンライン",
  "common.statusStale": "古い",
  "common.statusSyncing": "同期中",
  "common.stillNeedHelp": "まだお困りですか?",
  "common.stillNeedHelpDescription": "この記事で問題が解決しなかった場合は、直接サポートいたします。",
  "common.subscribeNow": "今すぐ登録 - トライアルなし",
  "common.sumOverThePeriod": "期間累計",
  "common.switchToPremium": "SmartMixin プレミアムに切り替える",
  "common.temperatureShort": "気温",
  "common.temperatureSummary": "温度の概要",
  "common.thankYouForFeedback": "フィードバックありがとうございます！",
  "common.thenPrice": "その後 {price}",
  "common.timeSelection": "時間の選択",
  "common.timezone": "タイムゾーン",
  "common.totalDuration": "合計期間",
  "common.tryAnotherLocation": "この場所の近くに気象観測所が見つかりませんでした。別のエリアで検索してみてください。",
  "common.unknown": "未知",
  "common.untilChanged": "変わるまで",
  "common.untilTime": "{time} まで",
  "common.updateAvailable": "アップデートがあります",
  "common.updateAvailableOpenAppStore": "タップして App Store を開く",
  "common.updateAvailableOpenGooglePlay": "タップして Google Play を開く",
  "common.updateAvailableVersion": "アップデートがあります: v{version}",
  "common.upgrade": "アップグレード",
  "common.upgradeRequiredAndroid": "アプリケーションのアップグレードが必要です。 Google Play にアクセスしてアップグレードしてください。",
  "common.upgradeRequiredIos": "アプリケーションのアップグレードが必要です。 App Store にアクセスしてアップグレードしてください。",
  "common.validate": "検証",
  "common.validEmail": "有効なメールアドレスが必要です。",
  "common.very_low": "とても低い",
  "common.visitNetatmoWebsite": "Netatmo Web サイトにアクセスしてください",
  "common.wasArticleHelpful": "この記事は役に立ちましたか？",
  "common.weatherCondition": "天気の状態",
  "common.weatherflowNCRain": "NC Rain (Nearcast Rain)",
  "common.weatherflowNCRainDescription": "NC Rain は、Nearcast Technology を活用した Tempest Weather System 経由で提供される追加のデータ ソースです。 NC の雨データは、近隣レベルでのテンペスト周辺の平均降雨量の推定値です。",
  "common.weatherForecastModels": "天気予報モデル",
  "common.weatherIntelligencePlatform": "天気インテリジェンスプラットフォーム",
  "common.weatherMap": "天気図",
  "common.weatherMapMetaDescription": "SmartMixinは世界中の気象状況に対応したインタラクティブな天気図とレーダーマップを提供します。",
  "common.weatherObservations": "気象観測",
  "common.weatherStation": "気象観測所",
  "common.weatherStations": "気象観測所",
  "common.welcome": "SmartMixin へようこそ!",
  "common.whenBackHome": "いつ家に帰りますか？",
  "common.wifiStrength": "WiFiの強さ",
  "common.wind": "風",
  "common.windMeasurement": "風力測定",
  "common.windSpeed": "風速",
  "common.windSummary": "風まとめ",
  "common.yearToDate": "年初来",
  "common.yes": "はい",
  "common.zoomImage": "画像を拡大",
  "forecastMaps.addColor": "色を追加",
  "forecastMaps.addLayer": "レイヤーを追加",
  "forecastMaps.autoPreview": "自動",
  "forecastMaps.backToMaps": "マップ一覧に戻る",
  "forecastMaps.browseMaps": "マップを閲覧",
  "forecastMaps.build": "生成",
  "forecastMaps.buildCompleted": "生成が完了しました",
  "forecastMaps.builderMetaDescription": "気象モデルのレイヤーからカスタム予報マップを作成します。",
  "forecastMaps.builderTitle": "マップビルダー",
  "forecastMaps.buildFailed": "生成に失敗しました。もう一度お試しください。",
  "forecastMaps.buildNotPossible": "このマップはまだ生成できません — 利用可能な予報データがありません。",
  "forecastMaps.buildProgress": "レンダリング中… {completed}/{total} ステップ",
  "forecastMaps.buildStarting": "生成を開始しています…",
  "forecastMaps.byModel": "モデル別",
  "forecastMaps.byZone": "ゾーン別",
  "forecastMaps.colormap": "カラーマップ",
  "forecastMaps.colormapCustom": "カスタムカラー",
  "forecastMaps.colormapGroupDomain": "気象プリセット",
  "forecastMaps.colormapGroupMatplotlib": "科学プリセット",
  "forecastMaps.colorScale": "カラースケール",
  "forecastMaps.comingSoon": "このビューは近日公開予定です。",
  "forecastMaps.contourLevels": "等値線レベル",
  "forecastMaps.countryCanada": "カナダ",
  "forecastMaps.countryFrance": "フランス",
  "forecastMaps.countryGermany": "ドイツ",
  "forecastMaps.countryItaly": "イタリア",
  "forecastMaps.countryScandinavia": "スカンジナビア",
  "forecastMaps.countrySpain": "スペイン",
  "forecastMaps.countrySwitzerland": "スイス",
  "forecastMaps.countryUnitedStates": "アメリカ合衆国",
  "forecastMaps.customColormapMinColors": "カスタムカラーマップには少なくとも2色が必要です",
  "forecastMaps.customExtent": "カスタム範囲",
  "forecastMaps.deleteMap": "マップを削除",
  "forecastMaps.deleteMapBody": "「{name}」とそのレンダリング結果は完全に削除されます。",
  "forecastMaps.deleteMapTitle": "このマップを削除しますか？",
  "forecastMaps.displayName": "表示名",
  "forecastMaps.downloadMp4": "MP4をダウンロード",
  "forecastMaps.downscaling": "矢羽の間引き係数",
  "forecastMaps.dpi": "DPI",
  "forecastMaps.drawArea": "範囲を描画",
  "forecastMaps.east": "東",
  "forecastMaps.editMap": "マップを編集",
  "forecastMaps.exportBuilding": "動画を作成中…",
  "forecastMaps.exportError": "動画のエクスポートに失敗しました。もう一度お試しください。",
  "forecastMaps.exportMp4": "MP4をエクスポート",
  "forecastMaps.exportNotReady": "動画はまだ準備できていません。後でもう一度お試しください。",
  "forecastMaps.extentDrawHint": "マップ上をドラッグして範囲を描いてください",
  "forecastMaps.extentInvalid": "西は東より小さく、南は北より小さくする必要があります",
  "forecastMaps.extentPanZoomHint": "範囲が枠いっぱいになるまで移動・ズームしてください",
  "forecastMaps.flipbookView": "アニメーション",
  "forecastMaps.forecastModel": "予報モデル",
  "forecastMaps.forkAndEdit": "複製して編集",
  "forecastMaps.height": "高さ（インチ）",
  "forecastMaps.hourOffset": "+{hour} 時間",
  "forecastMaps.invalidHexColor": "無効な色です — #RRGGBB を使用してください",
  "forecastMaps.layers": "レイヤー",
  "forecastMaps.layerTypeBarbs": "矢羽（風）",
  "forecastMaps.layerTypeContour": "等値線",
  "forecastMaps.layerTypeFilledContour": "塗りつぶし等値線",
  "forecastMaps.layerTypeMagnitude": "大きさ",
  "forecastMaps.layerTypeRaster": "ラスター",
  "forecastMaps.layerTypeVectorField": "ベクトル場",
  "forecastMaps.leave": "移動する",
  "forecastMaps.levelsCount": "本数",
  "forecastMaps.levelsInvalid": "無効な等値線レベルです",
  "forecastMaps.levelsModeArange": "固定間隔",
  "forecastMaps.levelsModeExplicit": "明示的な値",
  "forecastMaps.levelsModeLinspace": "等間隔（本数指定）",
  "forecastMaps.levelsStep": "間隔",
  "forecastMaps.levelsValues": "値",
  "forecastMaps.levelsValuesHint": "カンマ区切り・昇順",
  "forecastMaps.localTimeHint": "現地時間で表示",
  "forecastMaps.map": "マップ",
  "forecastMaps.mapDescription": "説明",
  "forecastMaps.mapName": "マップ名",
  "forecastMaps.mapNameRequired": "名前を入力してください",
  "forecastMaps.mapSettings": "マップ設定",
  "forecastMaps.mapView": "インタラクティブマップ",
  "forecastMaps.maxLayersReached": "このマップはレイヤーの上限（{max}）に達しました。",
  "forecastMaps.maxValue": "最大値",
  "forecastMaps.memoryBudgetExceeded": "解像度がレンダリング上限を超えています — DPIまたは高さを下げてください",
  "forecastMaps.memoryBudgetUsage": "レンダリング上限: {percent}%",
  "forecastMaps.metaDescription": "気象モデルの計算結果から生成されたアニメーション予報マップ。",
  "forecastMaps.metric": "気象要素",
  "forecastMaps.metricRequired": "気象要素を選択してください",
  "forecastMaps.metricUnavailable": "このモデルでは利用できません",
  "forecastMaps.minBelowMax": "最小値は最大値より小さくする必要があります",
  "forecastMaps.minMaxRequired": "このレイヤータイプには最小値と最大値が必要です",
  "forecastMaps.minValue": "最小値",
  "forecastMaps.modelNoRun": "完了した計算がまだありません",
  "forecastMaps.moveLayerDown": "下へ移動",
  "forecastMaps.moveLayerUp": "上へ移動",
  "forecastMaps.myMaps": "マイマップ",
  "forecastMaps.nanClipToMin": "最小値に丸める",
  "forecastMaps.nanMask": "マスク",
  "forecastMaps.nanPolicy": "欠損データ",
  "forecastMaps.nanSkip": "スキップ",
  "forecastMaps.newMap": "新規マップ",
  "forecastMaps.noCompletedRun": "このマップはまだ生成されていません。しばらくしてからご確認ください。",
  "forecastMaps.noLayers": "レイヤーがありません。レイヤーを追加して始めましょう。",
  "forecastMaps.noMapsAvailable": "予報マップはまだありません。",
  "forecastMaps.north": "北",
  "forecastMaps.opacity": "不透明度",
  "forecastMaps.overlayLegend": "凡例",
  "forecastMaps.pause": "一時停止",
  "forecastMaps.play": "再生",
  "forecastMaps.pointValueError": "この地点の予報を読み込めませんでした。",
  "forecastMaps.pointValueLoading": "予報を読み込んでいます…",
  "forecastMaps.pointValueUnavailable": "この時刻のデータはありません。",
  "forecastMaps.presets": "プリセット",
  "forecastMaps.preview": "プレビュー",
  "forecastMaps.previewEmptyHint": "プレビューを表示するには、有効なレイヤーを1つ以上設定してください。",
  "forecastMaps.previewFailed": "プレビューに失敗しました",
  "forecastMaps.previewHour": "予報時刻（時間）",
  "forecastMaps.previewRendering": "プレビューをレンダリング中…",
  "forecastMaps.projection": "投影法",
  "forecastMaps.projectionLambertConformal": "ランベルト正角円錐",
  "forecastMaps.projectionMercator": "メルカトル",
  "forecastMaps.projectionPlateCarree": "正距円筒（Plate carrée）",
  "forecastMaps.projectionStereographic": "ステレオ投影",
  "forecastMaps.regionEurope": "ヨーロッパ",
  "forecastMaps.regionNorthAmerica": "北アメリカ",
  "forecastMaps.removeColor": "色を削除",
  "forecastMaps.removeLayer": "レイヤーを削除",
  "forecastMaps.retry": "再試行",
  "forecastMaps.run": "ラン: {run}",
  "forecastMaps.save": "保存",
  "forecastMaps.selectExtentOnMap": "マップ上で範囲を選択",
  "forecastMaps.south": "南",
  "forecastMaps.title": "予報マップ",
  "forecastMaps.uMetric": "U成分",
  "forecastMaps.unitConversion": "単位変換",
  "forecastMaps.unitNone": "なし",
  "forecastMaps.unsavedChangesBody": "保存されていない変更があります。破棄して移動しますか？",
  "forecastMaps.unsavedChangesTitle": "未保存の変更",
  "forecastMaps.useCurrentView": "現在の表示を使用",
  "forecastMaps.useModelDomain": "オフ: モデルの全領域を使用します",
  "forecastMaps.utcTime": "UTC: {time}",
  "forecastMaps.uvMetricsDiffer": "U成分とV成分は異なる必要があります",
  "forecastMaps.validTime": "対象時刻: {time}",
  "forecastMaps.valueBetween": "{min}から{max}の間である必要があります",
  "forecastMaps.variable": "変数",
  "forecastMaps.viewMap": "マップを見る",
  "forecastMaps.vMetric": "V成分",
  "forecastMaps.west": "西",
  "forecastMaps.windAnimation": "風のアニメーション",
  "intro.locationDescription": "正確な場所に基づいた天気予報を受け取るために、位置情報へのアクセスを許可してください。もう一般的な予報ではありません。",
  "intro.locationTitle": "あなたのための天気予報",
  "intro.notificationDescription": "雨・雪・悪天候など、あなたにとって重要な天候の変化をタイムリーにお知らせする通知を有効にしましょう。",
  "intro.notificationsTitle": "天気の変化を見逃さない",
  "intro.readyDescription": "正確な予報、リアルタイムの気象情報、世界中の観測データを、1つの強力なアプリでご利用いただけます。",
  "intro.readyTitle": "準備完了！",
  "intro.welcomeDescription": "主要な気象機関による超局地的な予報に加え、世界中の40,000以上の気象観測所からのリアルな現在と過去の気象状況も確認できます。",
  "intro.welcomeTitle": "あなたの天気、再定義",
  "landing.alerts": "アラート",
  "landing.alertsDescription": "独自のアラートを作成し、トリガーされるとすぐに通知を受け取ります。",
  "landing.featureAlertsDescription": "気温、風、降水量など、気になる条件のカスタムアラートを設定できます。",
  "landing.featureAlertsTitle": "スマートアラート",
  "landing.featureAnalyticsDescription": "インタラクティブなグラフ、並べて比較、基本指標を超えるトレンド分析でデータを深く探索できます。",
  "landing.featureAnalyticsTitle": "強力な分析",
  "landing.featureExportDescription": "Excel分析、他システムとの連携、バックアップ用にCSV形式でデータをダウンロード。",
  "landing.featureExportTitle": "どこでもエクスポート",
  "landing.featureForecastDescription": "GFS、ECMWF、ICONなど10以上の気象モデルの予報を比較して、お住まいの地域に最適なモデルを見つけましょう。",
  "landing.featureForecastTitle": "予報の比較",
  "landing.featureHistoryDescription": "時間単位、日単位、月単位のスケールで過去データにアクセス。研究や個人アーカイブ用にCSVでエクスポート可能。",
  "landing.featureHistoryTitle": "豊富な履歴",
  "landing.featureMultiBrandDescription": "Netatmo、Ecowitt、Ambient Weather、Davis、WeatherFlowなどのステーションを接続—すべて1つのダッシュボードで。",
  "landing.featureMultiBrandTitle": "マルチブランド対応",
  "landing.featuresSubtitle": "基本的な気象ステーションアプリ以上を求める気象愛好家のために設計されています。",
  "landing.featuresTitle": "気象分析に必要なすべて",
  "landing.finalCtaButton": "無料アカウントを作成",
  "landing.finalCtaSubtitle": "SmartMixinを気象データに信頼する数千人の気象愛好家に加わりましょう。",
  "landing.finalCtaTitle": "気象体験をアップグレードする準備はできましたか？",
  "landing.forecastDescription": "いくつかの最良の天気予報モデルにアクセスし、それらを比較して、天気がどうなるかを独自に把握してください。",
  "landing.forecasts": "予報",
  "landing.heroCta": "無料で始める",
  "landing.heroDescription": "あらゆるブランドの複数の気象ステーションを統合し、予報モデルを比較し、詳細なグラフとエクスポートでデータを分析できます。",
  "landing.heroSecondaryCta": "機能を見る",
  "landing.heroTagline": "気象愛好家のために",
  "landing.heroTitle": "すべての気象データ。ひとつのプラットフォーム。",
  "landing.pricingFeatureAdvancedMetrics": "高度な指標",
  "landing.pricingFeatureAlerts": "カスタムアラート",
  "landing.pricingFeatureExport": "データエクスポート（CSV）",
  "landing.pricingFeatureForecastComparison": "予報モデル比較",
  "landing.pricingFeatureForecasts": "予報モデル",
  "landing.pricingFeatureForecastsFreeTier": "1モデル",
  "landing.pricingFeatureForecastsPremiumTier": "全モデル（10以上）",
  "landing.pricingFeatureReports": "分析とレポート",
  "landing.pricingFeatureStationComparison": "ステーション比較",
  "landing.pricingFeatureWidgets": "ホーム画面ウィジェット",
  "landing.pricingFeatureYearOverYear": "前年比分析",
  "landing.pricingFree": "無料",
  "landing.pricingFreeCta": "始める",
  "landing.pricingFreePrice": "0 €",
  "landing.pricingMostPopular": "人気No.1",
  "landing.pricingPremium": "プレミアム",
  "landing.pricingPremiumCta": "始める",
  "landing.pricingPremiumDescription": "月額1.99€から — ウェブ、App Store、Google Playで購読",
  "landing.pricingSubtitle": "無料で始めて、必要に応じてアップグレード。",
  "landing.pricingTitle": "シンプルで透明な料金",
  "landing.smartMixinDescription": "SmartMixin は、気象観測所や世界中の 40,000 以上の気象観測所へのアクセスを提供するアプリケーションです。気象データを確認して理解するのに役立ちます。",
  "landing.statBrands": "対応ブランド",
  "landing.statForecasts": "予報モデル",
  "landing.statStations": "接続ステーション",
  "landing.supportedDevices": "サポートされているデバイス",
  "landing.supportedDevicesDescription": "世界気象機関の観測所に加えて、SmartMixin はますます多くの気象観測所ブランドをサポートしています。",
  "landing.supportedDevicesNote": "さらに世界気象機関の40,000以上の公共観測所",
  "landing.supportedDevicesSubtitle": "主要ブランドの気象ステーションを接続し、すべてのデータを一か所で確認できます。",
  "landing.supportedDevicesTitle": "お使いの観測所に対応",
  "landing.thermostatDescription": "Netatmoサーモスタットを接続して、暖房パターンと外部条件を関連付けます。",
  "landing.thermostatManufacturers": "サーモスタットのメーカーは、暖房と屋外条件を関連付けることもサポートされています。",
  "landing.thermostatTitle": "スマートホーム連携",
  "landing.weatherAnalysis": "気象分析",
  "landing.weatherAnalysisDescription": "SmartMix には、気象データを分析できる多数のデータ視覚化機能が付属しています。",
  "landing.weatherAssistant": "お天気アシスタント",
  "landing.weatherAssistantDescription": "現在の気象状況、過去の気象状況、または予測の気象状況に興味がある場合でも、SmartMixin は必要なときにいつでも多数の洞察を提供します。",
  "landing.weatherForecastModels": "天気予報モデル",
  "landing.weatherForecastModelsDescription": "SmartMixin は、最も正確な天気予報モデルへのアクセスを提供します。簡単に予測を比較し、独自のアイデアを作成できます。",
  "landing.weatherMap": "天気図",
  "landing.weatherMapDescription": "地図を参照して、世界中の天気を視覚化します。",
  "network.cancelError": "リクエストはキャンセルされました",
  "network.connectionError": "サーバーが利用できません",
  "network.networkError": "ネットワークが利用できません",
  "network.serverError": "何か問題が発生しました...",
  "network.timeoutError": "接続タイムアウト",
  "network.unknownError": "不明なエラー",
  "providerHints.ambientWeatherApiKey": "ambientweather.net のアカウント設定で作成します。",
  "providerHints.davisApiSecret": "V2 API キーを作成したときに一度だけ表示されます — 大切に保管してください。",
  "providerHints.davisV2ApiKey": "weatherlink.com の V2 API キーのページから取得します。",
  "providerHints.ecowittApi": "Ecowitt アカウントの API ページから取得します。",
  "providerHints.ecowittApp": "アプリケーションキーも Ecowitt アカウントから取得します。",
  "providerHints.myAcuriteCredentialsBanner": "My AcuRite アカウントのメールとパスワードを使用してください — SmartMixin のログインではありません。",
  "providerHints.myAcuriteEmail": "My AcuRite アカウントのメールアドレス — SmartMixin のログインではありません。",
  "providerHints.myAcuritePassword": "My AcuRite アカウントのパスワード。",
  "providerHints.weatherflowToken": "tempestwx.com → 設定 → データ認証から取得する個人利用トークン。",
  "providerHints.wundergroundEditKey": "別のキーを使用する",
  "providerHints.wundergroundKey": "Weather Underground アカウントの API キーページから取得する長い文字列です — wunderground.com のパスワードではありません。",
  "providerHints.wundergroundKeyExample": "例: 5f6a7b8c9dabcdef…",
  "providerHints.wundergroundKeyVerified": "API キーを確認しました",
  "providerHints.wundergroundKeyVerifying": "キーを確認しています…",
  "providerHints.wundergroundNoStationsNearby": "この場所の近くにステーションが見つかりません。ステーション ID を直接入力してみてください。",
  "providerHints.wundergroundStationId": "任意の Weather Underground のステーション ID — ご自身のもの、または近くの公開ステーションでも構いません。",
  "providerHints.wundergroundStationIdExample": "例: KCASANFR123",
  "providerIntro.ambientWeatherStep2": "Ambient Weather の API キーを取得してください。",
  "providerIntro.davisStep2": "Davis の V2 API キーと API シークレットを取得してください。",
  "providerIntro.ecowittStep2": "Ecowitt の API キーとアプリケーションキーを取得してください。",
  "providerIntro.getStarted": "はじめる",
  "providerIntro.myAcuriteStep2": "既存の My AcuRite アカウントのメールとパスワードを使用してください。",
  "providerIntro.netatmoEnergyStep2": "プロンプトが表示されたら Netatmo にサインインしてください — API キーは不要です。",
  "providerIntro.netatmoWeatherStep2": "プロンプトが表示されたら Netatmo にサインインしてください — API キーは不要です。",
  "providerIntro.signupBanner": "もう少しです — {provider} を接続するために無料の SmartMixin アカウントを作成してください。",
  "providerIntro.step1": "SmartMixin アカウントにサインインしてください（{provider} のログインではありません）。",
  "providerIntro.step3EmailPassword": "ここに入力してください。",
  "providerIntro.step3KeyOrToken": "ここに貼り付けてください。",
  "providerIntro.step3OAuth": "ポップアップで SmartMixin を承認してください。",
  "providerIntro.step3Wunderground": "API キーを貼り付けてから、近くのステーションを選択するか、任意のステーション ID を入力してください。",
  "providerIntro.title": "{provider} を接続する",
  "providerIntro.weatherflowStep2": "Tempest の個人利用トークンを取得してください。",
  "providerIntro.wundergroundBrowsePublic": "ステーションをお持ちでない方は公開ステーションを探す",
  "providerIntro.wundergroundFindNearby": "近くのステーションを探す",
  "providerIntro.wundergroundOrEnterId": "またはステーション ID を入力する",
  "providerIntro.wundergroundStep2": "Weather Underground の API キーを取得してください。その後、ご自身のものでも公開ステーションでも、任意のステーションを接続できます。",
  "reports.agroMeteorology": "農業気象学",
  "reports.analysis": "分析",
  "reports.annualCumulativeRainfallComparison": "年間累積降水量の比較",
  "reports.annualHeatingDurationComparison": "年間暖房時間の比較",
  "reports.annualHeatingEfficiency": "年間暖房効率",
  "reports.annualIndoorComparison": "年間屋内比較",
  "reports.annualIndoorReport": "屋内年次報告書",
  "reports.annualOutdoorComparison": "年間屋外比較",
  "reports.annualOutdoorReport": "アウトドア年次報告書",
  "reports.annualReport": "年次報告",
  "reports.annualSolarReport": "年次太陽報告書",
  "reports.annualWaterBalance": "年間の水収支",
  "reports.annualWaterBalanceCarryOver": "前年から繰り越す",
  "reports.annualWaterBalanceDescription": "水バランス（簡易版、雨と蒸発散のみを使用）は給水管理に役立ちます",
  "reports.avgHumidity": "平均湿度",
  "reports.avgMaxTemperature": "平均温度最大値",
  "reports.avgMetric": "平均{metric}",
  "reports.avgMinTemperature": "平均 T°min",
  "reports.avgPressure": "平均圧力",
  "reports.avgTemperature": "平均温度",
  "reports.comfortable": "快適 (45% {lessThan} 湿度 ≤ 60%)",
  "reports.cumulativeRainfall": "累積降水量",
  "reports.cumulativeRainfallDescription": "選択した期間に蓄積した総降水量を確認できます。",
  "reports.dailyMaxRainfall": "1 日あたりの最大値降雨",
  "reports.dataExport": "データのエクスポート",
  "reports.dataExportXlsxFormatDescription": "ステーションのすべてのデータを Excel 形式 (*.xlsx) でエクスポートします。ボタンをクリックすると、数分後に処理されたデータが記載された電子メールが届きます。",
  "reports.daysWithFrost": "霜が降りる日",
  "reports.daysWithoutThaw": "雪解けのない日々",
  "reports.daysWithStrongFrost": "霜が強い日",
  "reports.emailSent": "電子メールがあなたのメールボックスに送信されました",
  "reports.grasslandTemperatureSum": "草地温度合計",
  "reports.grasslandTemperatureSumDescription": "春に {threshold} の合計を超えた場合、植生の持続可能な開始に達しています (ヨーロッパで機能)",
  "reports.growingDegreeDays": "生育度日",
  "reports.highPressure": "高気圧 (平均気圧 ≥ 1013 mbar)",
  "reports.indoorReport": "インドアレポート",
  "reports.keyFacts": "重要な事実",
  "reports.longestRunOfRainyDays": "雨の日が最も長く続く",
  "reports.longestRunWithoutRun": "雨が降らなかった最長ラン",
  "reports.lowPressure": "低圧 (平均圧力 {lessThan} 1013 mbar 未満)",
  "reports.maxHumidity": "最大湿度",
  "reports.maxMetric": "最大{metric}",
  "reports.maxPressure": "最大圧力",
  "reports.maxPressureMagnitude24h": "最大等級(/24H)",
  "reports.maxTemperature": "最高温度",
  "reports.maxTempGreaterThan": "T°max ≧",
  "reports.maxTempMagnitude24h": "最大等級(/24H)",
  "reports.minHumidity": "最低湿度",
  "reports.minMetric": "最小{metric}",
  "reports.minPressure": "最低圧力",
  "reports.minPressureMagnitude24h": "最小等級(/24H)",
  "reports.minTemperature": "最低温度",
  "reports.minTempMagnitude24h": "最小等級(/24H)",
  "reports.monthlyHeatingEfficiency": "月間暖房効率",
  "reports.monthlyIndoorReport": "月次屋内レポート",
  "reports.monthlyOutdoorReport": "月刊アウトドアレポート",
  "reports.monthlyReport": "月例報告",
  "reports.monthlySolarReport": "月次ソーラーレポート",
  "reports.monthlyWindReport": "月次風力レポート",
  "reports.numberOfDays": "日数",
  "reports.outdoorReport": "アウトドアレポート",
  "reports.rainfall": "降雨",
  "reports.rainyDays": "雨の日",
  "reports.relativelyWet": "比較的湿った状態 (60% {lessThan} 湿度 ≤ 80%)",
  "reports.sendEmail": "メールを送る",
  "reports.tooDry": "乾燥しすぎ (湿度 ≤ 45%)",
  "reports.tooWet": "湿りすぎます (湿度 {greaterThan} 80%)",
  "reports.tropicalNights": "熱帯夜",
  "reports.waterBalance": "水分平衡",
  "reports.yearToDateTemperature": "年初から今日までの気温",
  "reports.yearToDateTemperatureComparison": "年初から今日までの気温の比較",
  "sensors.aqiByChannel": "チャンネル別AQI",
  "sensors.bgtSensors": "黒球温度 & WBGT",
  "sensors.cameraFeed": "カメラ",
  "sensors.compareAqi": "AQIを比較",
  "sensors.compareHumidity": "湿度を比較",
  "sensors.compareMoisture": "土壌水分を比較",
  "sensors.comparePm25": "PM2.5を比較",
  "sensors.compareTemperatures": "温度を比較",
  "sensors.depthByChannel": "チャンネル別深度",
  "sensors.heatStressExtreme": "極度の熱ストレス",
  "sensors.heatStressModerate": "中程度の熱ストレス",
  "sensors.heatStressNone": "熱ストレスなし",
  "sensors.heatStressStrong": "強い熱ストレス",
  "sensors.heatStressVeryStrong": "非常に強い熱ストレス",
  "sensors.humidityByChannel": "チャンネル別湿度",
  "sensors.indoorAirQuality": "室内空気質",
  "sensors.indoorAirQualityPm": "PM2.5 & PM10 AQI",
  "sensors.indoorClimate": "室内気候",
  "sensors.indoorCo2Levels": "CO2レベル",
  "sensors.indoorTemperatureAndHumidity": "温度と湿度",
  "sensors.last24Hours": "24時間",
  "sensors.last30Days": "30日間",
  "sensors.last7Days": "7日間",
  "sensors.leafTemperatureByChannel": "チャンネル別葉温",
  "sensors.leafWetnessByChannel": "チャンネル別葉面湿度",
  "sensors.lightningSensor": "雷",
  "sensors.moistureByChannel": "チャンネル別土壌水分",
  "sensors.noDataAvailable": "データがありません",
  "sensors.pm10AndAqi": "PM10 & AQI",
  "sensors.pm1AndAqi": "PM1.0 & AQI",
  "sensors.pm25AndAqi": "PM2.5 & AQI",
  "sensors.pm25ByChannel": "チャンネル別PM2.5",
  "sensors.pm4AndAqi": "PM4.0 & AQI",
  "sensors.selectChannel": "チャンネルを選択",
  "sensors.sensorDetailDescription": "センサーチャンネルの履歴データとトレンドを表示します。",
  "sensors.sensorHistory": "センサー履歴",
  "sensors.soilConductivityByChannel": "チャンネル別導電率",
  "sensors.soilTemperatureByChannel": "チャンネル別土壌温度",
  "sensors.strikesToday": "今日の落雷数",
  "sensors.temperatureByChannel": "チャンネル別温度",
  "sensors.viewChart": "グラフを表示",
  "settings.about": "について",
  "settings.aboutDescription": "ライセンス契約、プライバシーポリシー",
  "settings.account": "アカウント",
  "settings.accountDescription": "プロフィール、パスワード変更",
  "settings.accountIntro": "データはあなたのアカウントに関するものです:",
  "settings.accountSection": "アカウント",
  "settings.appearance": "外観",
  "settings.appearanceDescription": "テーマと表示オプション",
  "settings.appVersion": "SmartMixin v{version}",
  "settings.arabic": "アラビア語",
  "settings.availableServices": "利用可能",
  "settings.bulgarian": "ブルガリア語",
  "settings.cannotDisconnectLastAccount": "唯一のログイン方法を切断することはできません。まず別のログイン方法を追加してください。",
  "settings.catalan": "カタルーニャ語",
  "settings.changeEmail": "メールアドレスを変更",
  "settings.changePassword": "パスワードを変更する",
  "settings.chartGestures": "チャート上のジェスチャー",
  "settings.chartGesturesDescription": "チャートをスワイプすると期間が変更され、チャートをピンチすると時間スケールが変更されます",
  "settings.connect": "接続",
  "settings.connected": "接続済み",
  "settings.connectedAccounts": "接続済みアカウント",
  "settings.connectedAccountsDescription": "Apple, Google, Facebook",
  "settings.connectedServices": "接続済み",
  "settings.connectedSince": "{date}から接続",
  "settings.connectionSuccess": "{provider}アカウントが正常に接続されました",
  "settings.contactUs": "お問い合わせ",
  "settings.contactUsDescription": "ヘルプまたはフィードバックを送信",
  "settings.croatian": "クロアチア語",
  "settings.currentPassword": "現在のパスワード",
  "settings.czech": "チェコ語",
  "settings.danish": "デンマーク語",
  "settings.dark": "暗いテーマ",
  "settings.dataDisplay": "データ表示",
  "settings.dateAndTime": "日時",
  "settings.disconnect": "切断",
  "settings.disconnectConfirmation": "{provider}アカウントを切断してもよろしいですか？",
  "settings.disconnectionSuccess": "{provider}アカウントが正常に切断されました",
  "settings.donateButton": "寄付する",
  "settings.donateDescription": "SmartMixinは少人数のチームで開発しています。お役に立てているなら、任意の金額の一回限りの寄付で開発を応援できます。これは贈り物であり、プランの変更や機能のロック解除は行われません。",
  "settings.donateSuccessBody": "皆さまの寄付がSmartMixinの運営と改善を支えています。心より感謝いたします。",
  "settings.donateSuccessTitle": "ご支援ありがとうございます！",
  "settings.donateTitle": "SmartMixinを応援する",
  "settings.dutch": "オランダ語",
  "settings.emailChange": "メールアドレスの変更",
  "settings.emailChangeConfirmation": "メールアドレス変更の確認",
  "settings.emailChangeFailure": "メールアドレス変更リンクが無効か期限切れです。",
  "settings.emailChangeSuccess": "メールアドレスが {newEmail} に正常に変更されました。",
  "settings.emailChangeVerificationSent": "新しいメールアドレスに確認メールが送信されました。受信トレイを確認し、リンクをクリックして変更を確認してください。",
  "settings.english": "英語",
  "settings.forecastModelOrderEmpty": "順序が保存されていません — デフォルトで GFS を使用します。",
  "settings.forecastModelOrderFreeHint": "プレミアムモデルには SmartMixin Premium のサブスクリプションが必要です。",
  "settings.forecastModelOrderHelp": "リスト内で各ステーションをカバーする最初のモデルを選択します。",
  "settings.forecastModelOrderReset": "デフォルトに戻す",
  "settings.forecastModelOrderTitle": "デフォルトの予報モデル",
  "settings.forecastModels": "予報モデル",
  "settings.forecastModelsDescription": "優先順位で並べ替え",
  "settings.french": "フランス語",
  "settings.german": "ドイツ語",
  "settings.gestures": "ジェスチャー",
  "settings.greek": "ギリシャ語",
  "settings.helpCenter": "ヘルプセンター",
  "settings.helpCenterDescription": "よくある質問とガイド",
  "settings.hungarian": "ハンガリー語",
  "settings.integrationsSection": "連携",
  "settings.italian": "イタリア語",
  "settings.japanese": "日本語",
  "settings.korean": "韓国語",
  "settings.language": "言語",
  "settings.languageDescription": "優先言語",
  "settings.light": "ライトテーマ",
  "settings.newEmailAddress": "新しいメールアドレス",
  "settings.newPassword": "新しいパスワード",
  "settings.newPasswordAgain": "新しいパスワードを再入力",
  "settings.norwegian": "ノルウェー語",
  "settings.notConnected": "未接続",
  "settings.notificationsSection": "通知",
  "settings.oldPassword": "以前のパスワード",
  "settings.ongoingNotificationEnabled": "常駐通知を有効にする",
  "settings.ongoingNotificationMetrics": "表示する指標",
  "settings.ongoingNotificationMetricsHint": "ドラッグして選択した指標を並べ替え",
  "settings.ongoingNotificationPermissionRequired": "通知の許可が必要です",
  "settings.ongoingNotificationStation": "気象観測所",
  "settings.passwordChange": "パスワードの変更",
  "settings.polish": "ポーランド語",
  "settings.portuguese": "ポルトガル語",
  "settings.preferencesSection": "設定",
  "settings.premium": "プレミアム",
  "settings.premiumActive": "アクティブ",
  "settings.premiumAnnualThenPrice": "その後 9.99 €/年",
  "settings.premiumAnnualTrialInfo": "{days}日間の無料トライアルから始めましょう",
  "settings.premiumCurrentPlan": "現在のプラン",
  "settings.premiumDescription": "サブスクリプションを管理",
  "settings.premiumDownloadApp": "購読するにはアプリをダウンロード：",
  "settings.premiumExpiresOn": "{date}に更新",
  "settings.premiumFreePlan": "無料",
  "settings.premiumInactive": "未登録",
  "settings.premiumManageWebSubscription": "サブスクリプションの管理、支払い方法の更新、またはキャンセル。",
  "settings.premiumPremiumPlan": "プレミアム",
  "settings.premiumSubscribeAnnual": "年額 — 9.99 €/年",
  "settings.premiumSubscribedOn": "{platform}で購読中",
  "settings.premiumSubscribeMonthly": "月額 — 1.99 €/月",
  "settings.premiumSubscribeOnWeb": "今すぐ登録して、すべてのプレミアム機能をアンロックしましょう。",
  "settings.premiumSubscriptionSuccess": "サブスクリプションが有効になりました！すべてのプレミアム機能をお楽しみください。",
  "settings.premiumSubscriptionSuccessTitle": "プレミアムへようこそ！",
  "settings.premiumWebappNotice": "購読はiOSまたはAndroidのSmartMixinモバイルアプリからのみ可能です。",
  "settings.privacyPolicy": "プライバシーポリシー",
  "settings.profile": "プロフィール",
  "settings.russian": "ロシア語",
  "settings.serbian": "セルビア語",
  "settings.settings": "設定",
  "settings.slovak": "スロバキア語",
  "settings.smallDecimals": "小数を小さく表示",
  "settings.smallDecimalsDescription": "小数点以下の数字を小さいサイズで表示",
  "settings.socialConnectionsIntro": "ソーシャルアカウントをリンクして素早くログインできます。いつでもアカウントを接続または切断できます。",
  "settings.spanish": "スペイン語",
  "settings.statusBarWidget": "ステータスバーウィジェット",
  "settings.statusBarWidgetDescription": "常に表示される気象データ",
  "settings.subscriptionSection": "サブスクリプション",
  "settings.supportSection": "サポート",
  "settings.swedish": "スウェーデン語",
  "settings.systemTheme": "システムテーマ",
  "settings.termsOfService": "利用規約",
  "settings.turkish": "トルコ語",
  "settings.ukrainian": "ウクライナ語",
  "settings.units": "単位",
  "settings.unitsDescription": "アプリケーション内で表示される測定単位",
  "settings.update": "アップデート",
  "settings.updateYourProfile": "プロフィールを更新する",
  "settings.weatherServices": "気象サービス",
  "settings.weatherServicesConnected": "{count, plural, =0 {接続されているサービスはありません} other {#件のサービスが接続されています}}",
  "settings.weatherServicesDescription": "Netatmo、Davis、Weatherflowなどを接続",
  "settings.windDirectionConvention": "風向矢印",
  "settings.windDirectionConventionDescription": "風向矢印の表示方法を選択",
  "settings.windDirectionMeteorological": "風上方向",
  "settings.windDirectionMeteorologicalDescription": "矢印は風の吹いてくる方向を示します（meteorological convention）",
  "settings.windDirectionOceanographic": "風下方向",
  "settings.windDirectionOceanographicDescription": "矢印は風の吹いていく方向を示します（oceanographic convention）",
  "units.absolutePressure": "絶対圧力",
  "units.airDensity": "空気密度",
  "units.airGap": "エアギャップ",
  "units.apparentTemperature": "体感温度",
  "units.AQI": "AQI",
  "units.AQI_24H": "24h AQI",
  "units.avg": "平均",
  "units.beaufort": "ビューフォート",
  "units.blackGlobeTemperature": "黒球温度",
  "units.boilerOn": "ボイラーON",
  "units.co2": "CO2",
  "units.conductivity": "導電率",
  "units.coolingDegreeDays": "冷房度日数",
  "units.dailyHeatingDuration": "毎日の加熱時間",
  "units.dailyPrecipitation": "日降水量",
  "units.dailyRain": "日降水量",
  "units.degreeDay": "度日",
  "units.degreeDayShort": "DD",
  "units.depth": "深さ",
  "units.depthSensors": "深度センサー",
  "units.dewPoint": "露点",
  "units.distance": "距離",
  "units.downTrend": "下",
  "units.E": "東",
  "units.E_long": "東",
  "units.ENE": "東北東",
  "units.ENE_long": "東北東",
  "units.ESE": "東南東",
  "units.ESE_long": "東南東",
  "units.ET": "蒸発散量",
  "units.ETshort": "ET",
  "units.feelLike": "体感温度",
  "units.feelsLike": "体感温度",
  "units.footMile": "フィート、マイル",
  "units.frostPoint": "霜点",
  "units.gust": "ガスト",
  "units.heatIndex": "暑さ指数",
  "units.heatingDegreeDays": "暖房度日",
  "units.heatingPower": "火力",
  "units.humidex": "ヒュミデックス",
  "units.humidity": "湿度",
  "units.inch": "インチ",
  "units.inchOfMercury": "水銀柱インチ",
  "units.kilometerPerHour": "時速キロメートル",
  "units.knot": "ノット",
  "units.last12Hours": "過去12時間",
  "units.last24Hours": "過去24時間",
  "units.last3Hours": "過去3時間",
  "units.last6Hours": "過去6時間",
  "units.lastHour": "最後の時間",
  "units.lastLightningImpact": "ラストインパクト",
  "units.lastMeasure": "最新の測定値",
  "units.leafSensors": "葉センサー",
  "units.leafWetness": "葉の湿り気",
  "units.lightningDistance": "距離",
  "units.lightningStrikeCount": "落雷回数",
  "units.lightningStrikeDistance": "落雷距離",
  "units.max": "最高",
  "units.max_gust": "最大。突風",
  "units.max_wind": "最大。風",
  "units.meterKilometer": "メートル、キロメートル",
  "units.meterPerSecond": "メートル/秒",
  "units.milePerHour": "時速マイル",
  "units.millibar": "ミリバール",
  "units.millimeter": "ミリメートル",
  "units.millimeterOfMercury": "水銀柱ミリメートル",
  "units.min": "最低",
  "units.N": "北",
  "units.N_long": "北",
  "units.NE": "北東",
  "units.NE_long": "北東",
  "units.NNE": "北北東",
  "units.NNE_long": "北北東",
  "units.NNW": "北北西",
  "units.NNW_long": "北北西",
  "units.noise": "ノイズ",
  "units.normalizedHeatingCoefficient": "正規化された発熱係数",
  "units.NW": "北西",
  "units.NW_long": "北西",
  "units.O3": "オゾン",
  "units.PM_1": "PM1",
  "units.PM_10": "PM10",
  "units.PM_2P5": "PM2.5",
  "units.precipitation": "降水量",
  "units.pressure": "気圧",
  "units.rain": "雨",
  "units.rainRate": "降水強度",
  "units.referenceTemperature": "基準温度",
  "units.relativePressure": "相対圧力",
  "units.S": "南",
  "units.S_long": "南",
  "units.SE": "南東",
  "units.SE_long": "南東",
  "units.setPoint": "設定値",
  "units.snow": "雪",
  "units.snowfall": "降雪量",
  "units.soilMoisture": "水分",
  "units.soilSensors": "土壌センサー",
  "units.solarEnergy": "太陽光エネルギー",
  "units.solarRadiation": "日射",
  "units.speed": "スピード",
  "units.SSE": "南南東",
  "units.SSE_long": "南南東",
  "units.SSW": "南南西",
  "units.SSW_long": "南南西",
  "units.stableTrend": "安定した",
  "units.sum": "和",
  "units.SW": "南西",
  "units.SW_long": "南西",
  "units.temperature": "温度",
  "units.temperatureAndHumiditySensors": "温度および湿度センサー",
  "units.temperatureSensors": "温度および湿度センサー",
  "units.thsw": "THSW",
  "units.thw": "THW",
  "units.today": "今日",
  "units.upTrend": "上",
  "units.uv": "紫外線",
  "units.visibility": "可視性",
  "units.W": "西",
  "units.W_long": "西",
  "units.wetBulbGlobeTemperature": "ウェブバルブグローブ温度",
  "units.wetBulbTemperature": "湿球温度",
  "units.wind": "風",
  "units.windChill": "風の寒さ",
  "units.windDirection": "風向",
  "units.windRun": "ウィンドラン",
  "units.windRunDescription": "風速は、一定期間に風が伝わった合計距離です。",
  "units.WNW": "西北西",
  "units.WNW_long": "西北西",
  "units.WSW": "西南西",
  "units.WSW_long": "西南西"
}
